import Vue from 'vue';
import VueRouter from 'vue-router';

import Layout from '../views/layout/layout.vue';  //盒子
import HomePage from '../views/homePage/homePage.vue';  //首页；

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    {
        path: '/',
        name: 'Layout',
        component: Layout,
        redirect: '/homePage',
        children: [
            //首页；
            {
                path: '/homePage',
                name: 'HomePage',
                component: HomePage
            },
            //产品中心
            {
                path: '/productCenter',
                name: 'ProductCenter',
                component: () => import('@/views/productCenter/productCenter.vue'),
            },
            //团队介绍
            {
                path: '/aboutMy',
                name: 'AboutMy',
                component: () => import('@/views/aboutMy/aboutMy.vue'),
            },
            //企业文化
            {
                path: '/corporateCulture',
                name: 'CorporateCulture',
                component: () => import('@/views/corporateCulture/corporateCulture.vue'),
            },
            //联系我们
            {
                path: '/contactUs',
                name: 'ContactUs',
                component: () => import('@/views/contactUs/contactUs.vue'),
            }

        ]
    },
]

const router = new VueRouter({
    routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

export default router
